export enum TimesheetStatusReportHiddenColumns {
  Customer = 'customer',
  Member = 'member',
}
